import React from 'react';
import image from 'assets/media/twoNconfig.png';
import { Image } from 'semantic-ui-react';
import styles from './styles.module.scss';

export const AccessManagement2NPreview = () => (
  <Image
    src={image}
    alt="2n access management"
    className={styles.image}
  />
);
